<template>
    <div class="favorite-button" @click.stop.prevent="toggleFavorite" :class="{'is-favorite': isFavorite}">
        <span class="favorite-icon">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="26 6 15 21">
                <path class="heart-path" d="M39.42,25.02h-8.26c-1.56,0-3.03-.61-4.13-1.71l-.09-.09c-1.24-1.24-1.81-3.02-1.52-4.76.3-1.77,1.42-3.25,3.09-4.06.81-.4,1.77-.56,2.77-.47-.24-2.77,1.65-5.28,4.46-5.86,1.71-.35,3.5.2,4.79,1.49l.26.26c1.02,1.02,1.58,2.37,1.58,3.81v8.44c0,1.62-1.32,2.94-2.94,2.94h0ZM30.73,16.24c-.45,0-.85.09-1.2.26-.99.49-1.64,1.32-1.81,2.35-.17.99.16,2.01.87,2.72l.09.09c.66.66,1.54,1.03,2.48,1.03h8.26c.34,0,.61-.27.61-.61v-8.45c0-.82-.32-1.58-.9-2.16l-.26-.26c-.72-.72-1.74-1.05-2.66-.86-1.91.4-2.76,2.04-2.6,3.45l.15,1.32c.04.35-.08.7-.33.95s-.6.38-.95.33l-1.33-.15c-.14-.02-.27-.02-.4-.02h0Z" />
                <path class="heart-fill" d="M30.73,16.24c-.45,0-.85.09-1.2.26-.99.49-1.64,1.32-1.81,2.35-.17.99.16,2.01.87,2.72l.09.09c.66.66,1.54,1.03,2.48,1.03h8.26c.34,0,.61-.27.61-.61v-8.45c0-.82-.32-1.58-.9-2.16l-.26-.26c-.72-.72-1.74-1.05-2.66-.86-1.91.4-2.76,2.04-2.6,3.45l.15,1.32c.04.35-.08.7-.33.95s-.6.38-.95.33l-1.33-.15c-.14-.02-.27-.02-.4-.02h0Z" />
            </svg>
        </span>
    </div>
</template>

<script>
export default {
    name: "FavoriteButton",

    props: {
        entityId: {
            type: Number,
            required: true
        }
    },

    data() {
        return {
            isFavorite: false
        }
    },

    mounted() {
        this.checkIfFavorite();
    },

    methods: {
        checkIfFavorite() {
            const favorites = JSON.parse(localStorage.getItem('drupal_favorites') || '[]');
            this.isFavorite = favorites.includes(this.entityId);
        },

        toggleFavorite() {
            let favorites = JSON.parse(localStorage.getItem('drupal_favorites') || '[]');
            if (this.isFavorite) {
                favorites = favorites.filter(id => id !== this.entityId);
            } else {
                favorites.push(this.entityId);
            }
            localStorage.setItem('drupal_favorites', JSON.stringify(favorites));
            this.isFavorite = !this.isFavorite;
            
            // Dispatch event for other components
            window.vueBase.eventBus.$emit('favorites-updated', favorites);
        }
    }
}
</script>

<style lang="scss" scoped>
.favorite-button {
    cursor: pointer;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    color: #000;
    transition: color 0.3s ease;
    background-color: #fff;
    padding: 0.2rem 0.4rem 0.4rem 0.2rem;
    border-radius: 50%;
    width: 2rem;
    height: 2rem;

    .heart-path {
        fill: #23201E;
    }

    .heart-fill {
        fill: none;
    }
    
    &.is-favorite {
        color: #A1462B;

        .heart-path {
            fill: #A1462B;
        }

        .heart-fill {
            fill: currentColor;
        }
    }
    
    &:hover {
        opacity: 0.8;
    }
}
</style>
